import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiArrowRight,
  FiCalendar,
  FiCheckCircle,
  FiZap,
  FiShield,
  FiTrendingUp,
} from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="hero-blob hero-blob--a" />
        <div className="hero-blob hero-blob--b" />
        <div className="hero-grid" />
      </div>

      <div className="container hero-grid-wrap">
        <div className="hero-copy animate-up">
          <span className="chip">
            <span className="chip-dot" />
            New · IoT, AI & Digital Marketing studio
          </span>

          <h1 className="hero-title">
            Turn your <span className="gradient-text">website into</span>
            <br /> a sales machine.
          </h1>

          <p className="hero-sub">
            THINKINGWORLD designs, builds and grows modern web, mobile and
            IoT products — and the SEO + marketing engine behind them — for
            healthcare, real estate, ecommerce, nutrition and education brands.
          </p>

          <div className="hero-actions">
            <Link to="/schedule" className="btn btn-accent">
              <FiCalendar /> Schedule a free consult
            </Link>
            <Link to="/services" className="btn btn-ghost">
              Explore services <FiArrowRight />
            </Link>
          </div>

          <ul className="hero-bullets">
            <li><FiShield /> Built secure-by-default</li>
            <li><FiZap /> Ship in weeks, not quarters</li>
            <li><FiTrendingUp /> Designed to rank &amp; convert</li>
          </ul>
        </div>

        <div className="hero-visual animate-up">
          <div className="hero-card hero-card--main">
            <div className="hero-card-head">
              <span className="hero-card-dot" />
              <span className="hero-card-dot" />
              <span className="hero-card-dot" />
              <span className="hero-card-url">thinkingworld.com</span>
            </div>
            <div className="hero-card-body">
              <div className="hero-card-row">
                <strong>Visitors today</strong>
                <span className="hero-card-pill">+42%</span>
              </div>
              <div className="hero-card-bars">
                <span style={{ height: '36%' }} />
                <span style={{ height: '52%' }} />
                <span style={{ height: '68%' }} />
                <span style={{ height: '46%' }} />
                <span style={{ height: '78%' }} />
                <span style={{ height: '92%' }} />
                <span style={{ height: '64%' }} />
              </div>
              <div className="hero-card-foot">
                <span><FiCheckCircle /> Lighthouse 98</span>
                <span><FiCheckCircle /> Core Web Vitals: Pass</span>
              </div>
            </div>
          </div>

          <div className="hero-floater hero-floater--a">
            <div className="floater-icon"><FiTrendingUp /></div>
            <div>
              <strong>+3.4× organic leads</strong>
              <span>after SEO + redesign</span>
            </div>
          </div>

          <div className="hero-floater hero-floater--b">
            <div className="floater-avatars">
              <span style={{ background: '#6b5cff' }}>H</span>
              <span style={{ background: '#06b6d4' }}>R</span>
              <span style={{ background: '#10b981' }}>E</span>
            </div>
            <div>
              <strong>5 industries served</strong>
              <span>Healthcare · Real estate · Ecom · Nutrition · Edu</span>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-marquee">
        <div className="hero-marquee-track">
          {['React', 'Next.js', 'React Native', 'Node.js', 'TypeScript', 'Python', 'PostgreSQL', 'MongoDB', 'AWS', 'ESP32', 'MQTT', 'Shopify', 'WordPress', 'Google Ads', 'Meta Ads', 'WhatsApp Business']
            .concat(['React', 'Next.js', 'React Native', 'Node.js', 'TypeScript', 'Python', 'PostgreSQL', 'MongoDB', 'AWS', 'ESP32', 'MQTT', 'Shopify', 'WordPress', 'Google Ads', 'Meta Ads', 'WhatsApp Business'])
            .map((t, i) => (
              <span key={i} className="hero-marquee-item">{t}</span>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
